import React from 'react';
import { ChatService, StorageService } from 'services';
import { Globals } from 'utils';
import { CloseIcon, DocIcon, Document2Icon, PdfIcon, XLSIcon, ImageIcon } from 'assets/icons';
import moment from 'moment';

interface Props {
  onClose?: any;
  item?: any;
}

class ModalFiles extends React.Component<Props> {
  messagesEnd: any = null;

  state = {
    chat: null,
    messages: [],
  };

  componentDidMount() {
    this.load();
  }

  load = async (withoutScroll = false) => {
    const res: any = await ChatService.view({
      chat_id: this.props.item?.id,
      only_files: true,
    });
    this.setState(
      {
        chat: res.chat,
        messages: res.messages || [],
      },
      () => {
        if (!withoutScroll) {
          this.scrollToBottom();
        }
      },
    );
  };

  scrollToBottom = () => {
    this.messagesEnd.scrollTo({
      behavior: 'smooth',
      top: this.messagesEnd.scrollHeight,
    });
  };

  getThumbnail = (ext: string) => {
    const IMAGE_EXTS = [
      'png',
      'jpg',
      'jpeg',
      'gif',
      'webp',
      'bmp',
      'tiff',
      'tif',
      'avif',
      'heic',
      'heif',
    ];
    if (IMAGE_EXTS.includes(ext)) return ImageIcon;
    switch (ext) {
      case 'pdf':
        return PdfIcon;
      case 'doc':
      case 'docx':
        return DocIcon;
      case 'xls':
      case 'xlsx':
        return XLSIcon;
      default:
        return Document2Icon;
    }
  };

  openFile = async (key: string) => {
    const opened = await StorageService.openFile(key);
    if (!opened) Globals.showError('No se pudo obtener el archivo');
  };

  render() {
    return (
      <div id='client-view-files'>
        <div className='header-modal'>
          <button className='btn-close' onClick={() => this.props.onClose()}>
            <img src={CloseIcon} />
          </button>
          <p className='title'>Archivos adjuntos</p>
        </div>
        <div
          className='container-scroll-modal-right'
          ref={(el) => {
            this.messagesEnd = el;
          }}
        >
          <div className='container-messages'>
            {!!this.state.messages.length ? (
              this.state.messages.map((item: any) => {
                if (!item.file) return null;

                const extension = item.file.split('.').pop()?.toLowerCase();
                const previewImage = this.getThumbnail(extension);

                return (
                  <div className='message' key={item.id}>
                    <p className='name'>
                      {item.user?.name} {item.user?.lastname}
                    </p>
                    <button
                      type='button'
                      className='link-file'
                      onClick={() => this.openFile(item.file)}
                    >
                      <img src={previewImage} alt={`Vista previa de archivo ${extension}`} />
                      <p>
                        Archivo Adjunto <span>({extension})</span>
                      </p>
                    </button>
                    {moment(item.created_at).isValid() && (
                      <p className='date'>{moment(item.created_at).format('DD/MM/YYYY HH:mm')}</p>
                    )}
                  </div>
                );
              })
            ) : (
              <div className='no-items'>
                <p>No se han enviado archivos adjuntos</p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default ModalFiles;
